import { Currency } from '@/shared/api/topli/generated/Api'
import { enumToOptions } from './utils'

export const currencyOptions = enumToOptions(Currency, true)
